module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department04-ef6df484b0abcdf6b71bc3897700ee6b.jpg";